/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.upsell-accordion-wrapper').forEach(function (wrapper) {
    const title = wrapper.querySelector('.product__accordion__title');
    const products = wrapper.querySelector('.upsell__products');

    if (!title || !products) return;

    products.style.maxHeight = '0';
    products.style.overflow = 'hidden';
    products.style.transition = 'max-height 0.3s ease';

    title.addEventListener('click', function () {
      const isOpen = wrapper.classList.toggle('is-open');

      title.setAttribute('aria-expanded', isOpen);

      if (isOpen) {
        products.style.maxHeight = products.scrollHeight + 'px';
      } else {
        products.style.maxHeight = '0';
      }
    });
  });
});